<template>
  <el-button
    v-if="visible"
    class="image-batch-download-btn"
    type="text"
    :size="size"
    :loading="loading"
    @click.stop="handleClick"
  >{{ buttonText }}</el-button>
</template>

<script>
import { downloadImagesBatch, sanitizeDownloadNamePart } from "@/util/imageBatchDownload";

export default {
  name: "ImageBatchDownloadBtn",
  props: {
    /** 图片 URL 列表 */
    urls: { type: Array, default: () => [] },
    /** 下载文件名前缀（品牌-型号-…） */
    nameBase: { type: String, default: "" },
    /** 用于提示文案，如「瑕疵图」「商品图片」 */
    label: { type: String, default: "图片" },
    buttonText: { type: String, default: "一键下载" },
    size: { type: String, default: "mini" },
    /** 无图时不渲染按钮 */
    hideWhenEmpty: { type: Boolean, default: true },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    normalizedUrls() {
      return (this.urls || []).map((u) => String(u || "").trim()).filter(Boolean);
    },
    hasUrls() {
      return this.normalizedUrls.length > 0;
    },
    visible() {
      return this.hideWhenEmpty ? this.hasUrls : true;
    },
    resolvedNameBase() {
      return (
        sanitizeDownloadNamePart(this.nameBase) ||
        sanitizeDownloadNamePart(this.label) ||
        "图片"
      );
    },
  },
  methods: {
    async handleClick() {
      if (!this.hasUrls) {
        this.$message.warning(`暂无${this.label}`);
        return;
      }
      const apiUrl =
        this.$api && this.$api.api && this.$api.api.consignmentGradeDownloadImage;
      if (!apiUrl || !this.$https) {
        this.$message.error("下载接口未配置");
        return;
      }
      this.loading = true;
      try {
        const { ok, total } = await downloadImagesBatch({
          https: this.$https,
          apiUrl,
          urls: this.normalizedUrls,
          nameBase: this.resolvedNameBase,
        });
        if (ok === total) {
          this.$message.success(`已下载 ${ok} 张${this.label}`);
        } else if (ok > 0) {
          this.$message.warning(`成功下载 ${ok}/${total} 张，其余失败请重试`);
        } else {
          this.$message.error("下载失败，请稍后重试或联系管理员");
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.image-batch-download-btn {
  padding: 0;
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageBatchDownloadBtn.vue